// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_al-0";